<app-grid>
    <app-cell mobile="0:12"
              tablet="0:8"
              laptop="0:4"
              desktop="0:4"
    >
        <div class="forgot-password-success">
            <app-button theme="link"
                        icon="chevron-left"
                        layout="icon-label"
                        (click)="goToLogin()"
            >
                {{ 'auth.back-to-login' | translate }}
            </app-button>

            <div class="forgot-password-success__text">
                <h1>
                    {{ 'auth.sent' | translate }}
                </h1>

                <label class="dark-grey">
                    {{ 'auth.an-email-has-been-sent' | translate }}
                </label>
            </div>

            <app-button theme="dark"
                        layout="label-only"
                        routerLink="/"
                        class="forgot-password-success__button"
            >
                {{ 'auth.go-to-home' | translate }}
            </app-button>
        </div>
    </app-cell>
</app-grid>
